import React from "react";

const STATUS_MAP = {
    "in-review": { label: "In Review", className: "invoice-status-badge invoice-status-badge--warning" },
    accepted: { label: "Accepted", className: "invoice-status-badge invoice-status-badge--success" },
    rejected: { label: "Rejected", className: "invoice-status-badge invoice-status-badge--error" },
};

const InvoiceStatusBadge = ({ status }) => {
    const config = STATUS_MAP[status] ?? { label: status, className: "invoice-status-badge invoice-status-badge--muted" };
    return (
        <span className={config.className} aria-label={config.label}>
            <span className="invoice-status-badge__dot" aria-hidden="true" />
            {config.label}
        </span>
    );
};

export default InvoiceStatusBadge;
